import "./styles.scss";

import classnames from "classnames";

const mainClass = "check-input";

const CheckInput = ({ label, value, checked, onChange }) => {
  return (
    <div className={mainClass}>
      {label && <p className={`${mainClass}__label`}>{label}</p>}
      <div
        className={classnames(`${mainClass}__field`, {
          [`${mainClass}__field--checked`]: checked,
        })}
      >
        <input type="checkbox" checked={checked} onChange={onChange} />
        <i>
          <svg width="24" height="24" viewBox="0 0 24 24">
            <g transform="translate(-827 -661)">
              <circle
                cx="12"
                cy="12"
                r="12"
                transform="translate(827 661)"
                fill="#dbdbdb"
              />
              <g transform="translate(835 671)">
                <path
                  d="M15.364,6.818,9,12.818,5.364,9.39"
                  transform="translate(-5.364 -6.818)"
                  fill="none"
                  stroke="var(--color-white)"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.6"
                />
              </g>
            </g>
          </svg>
        </i>
        {value && <span>{value}</span>}
      </div>
    </div>
  );
};

export default CheckInput;
